import React, { useState, useEffect } from "react";
import { submissionsApi } from "../../../../../utils";
import Player from "../../../../cms/Player/Player";
import moment from "moment";
import { ActivityTypeEnumText } from "../../../models/ActivityTypeEnum";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import ReflectionAnswers from "../../ReflectionAnswers/ReflectionAnswers";
import { SourceTypeEnumText } from "../../../models/SourceTypeEnum";
import { throwApiError } from "../../../store/error-handling-actions";
import DynamicMessage from "../../../UI/Popups/DynamicMessage/DynamicMessage";
import { DynamicMessageTypeEnum } from "../../../models/DynamicMessageTypeEnum";
import { changeActiveLessonId } from "../../../../../store/general-actions";

const SLCPlayer = ({ contentDirPath, openProject, lessonId, lessonName, allUserIds, studyGroupId, onlyView, jumpToQuestion, assessment, scoreByRetries, finalAssessment, assessmentLearningCount }) => {
    const { hash } = useLocation();
    const navigate = useNavigate()
    const { externalId } = useSelector((state) => state.auth.user);
    const [submissions, setSubmissions] = useState();
    const [showReflection, setShowReflection] = useState(false)
    const [currentContentData, setCurrentContentData] = useState({ currentIndex: 0, contentsLength: 0 })
    const dispatch = useDispatch();
    const [message, setMessage] = useState(null)
    const { texts } = useSelector(state => state.translate);

    useEffect(() => {
        if (hash.includes("#openProject")) {
            navigate("", { replace: true, hash: "" })
            if (hash.split('#openProject').length > 1) {
                openProject(hash.split('#openProject')[1]);
            }
            else {
                openProject();
            }
        }
    }, [hash])

    useEffect(() => {
        if (lessonId) {
            const data = {
                toCId: lessonId,
                studyGroupId,
                activityType: ActivityTypeEnumText.Learning,
                sourceTypes: [SourceTypeEnumText.SLCQuestionnaire]
            }
            submissionsApi.submissionsFilterRangePost({ submissionsRangeFilter: data }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: error, error: error, statusCode: response?.statusCode, message: "submissionsFilterRangePost " + error.message, level: 1, component: "SLCPlayer", line: 43 }))
                }
                else {
                    setSubmissions(resdata)
                }
            })
        }

    }, [lessonId, studyGroupId])

    useEffect(() => {
        currentContentData.contentsLength > 0 && currentContentData.currentIndex === Math.floor(currentContentData.contentsLength * 0.8) && !assessment && studyGroupId && setShowReflection(true)
    }, [currentContentData])

    const postAnswer = (quetionId, question) => new Promise((resolve) => {
        if (lessonId) {
            const submissionSubmitInput = {
                lessonId: lessonId,
                assessmentExternalId: quetionId,
                score: parseInt(question.ansData.score, 10),
                solution: question.ansData.solution,
                success: question.ansData.success,
                studyGroupId,
            }

            submissionsApi.submissionsSubmitPost({ submissionSubmitInput: submissionSubmitInput }, (error, resdata, response) => {
                if (error) {
                    if (error?.response?.body?.code == 413) {
                        setMessage(<DynamicMessage
                            type={DynamicMessageTypeEnum.Warn}
                            title={texts.LessonInEditByTeamMember}
                            showCancel={false}
                            confirmText={texts.ok}
                            confirmFunc={() => setMessage(null)} />);
                    }
                    else
                        dispatch(throwApiError({ userMessage: error, error: error, statusCode: response?.statusCode, message: "submissionsSubmitPost " + error.message, level: 1, component: "SLCPlayer", line: 69 }))
                } else {
                    let newSub;
                    setSubmissions(preSubmissions => {
                        newSub = [...preSubmissions]
                        let existIndex = preSubmissions.findIndex(x => x.assessmentExternalId === quetionId);
                        if (existIndex > -1) {
                            newSub[existIndex] = { ...newSub[existIndex], solution: question.ansData.solution, success: question.ansData.success, attempts: question.submission?.attempts + 1 }
                        }
                        else {
                            newSub.push({ assessmentExternalId: quetionId, solution: question.ansData.solution, success: question.ansData.success, attempts: 0 })
                        }
                        return newSub;
                    });

                    if (!finalAssessment && newSub.length === assessmentLearningCount) {
                        dispatch(changeActiveLessonId(null, studyGroupId, null, allUserIds));
                    }
                    else {
                        dispatch(changeActiveLessonId(lessonId, studyGroupId, lessonName, allUserIds));
                    }
                    resolve()
                }
            })
        }
    })

    return (<>
        {submissions && externalId && <Player
            lessonId={lessonId}
            userId={externalId}
            submissions={submissions}
            postAnswer={postAnswer}
            setCurrentContentData={setCurrentContentData}
            studyGroupId={studyGroupId}
            contentDirPath={contentDirPath}
            openProject={openProject}
            onlyView={onlyView}
            jumpToQuestion={jumpToQuestion}
            scoreByRetries={scoreByRetries}
            currentContentData={currentContentData}>
        </Player>}
        {/* {submissions && externalId && <NewCmsLayout
            lessonId={lessonId}
            submissions={submissions}
            postAnswer={postAnswer}
            scoreByRetries={scoreByRetries}
            materialContentPath={contentDirPath}
            studyGroupId={studyGroupId}
            editMode={false}>
        </NewCmsLayout>} */}
        {showReflection && <ReflectionAnswers
            setShowReflection={setShowReflection}
            lessonId={lessonId}
            studyGroupId={studyGroupId} />
        }
        {message}
    </>)
}

export default SLCPlayer;

